<template>
  <a-modal title="邮寄申请详情" :visible="visible" @cancel="visible = false" :footer="null" width="600px">
    <a-descriptions :column="1" bordered>
      <a-descriptions-item label="用户ID">{{ detail.userId }}</a-descriptions-item>
      <a-descriptions-item label="用户昵称">{{ detail.userNickName }}</a-descriptions-item>
      <a-descriptions-item label="种子名称">{{ detail.seedName }}</a-descriptions-item>
      <a-descriptions-item label="气候名称">{{ detail.climateName }}</a-descriptions-item>
      <a-descriptions-item label="联系电话">{{ detail.contactPhone }}</a-descriptions-item>
      <a-descriptions-item label="物流公司">{{ detail.logisticsName }}</a-descriptions-item>
      <a-descriptions-item label="物流单号">{{ detail.logisticsNo }}</a-descriptions-item>
      <a-descriptions-item label="备注文本">{{ detail.remarkText }}</a-descriptions-item>
<!--      <a-descriptions-item label="审核状态">-->
<!--        <a-tag v-if="detail.auditStatus === 0" color="orange">待审核</a-tag>-->
<!--        <a-tag v-else-if="detail.auditStatus === 1" color="green">审核通过</a-tag>-->
<!--        <a-tag v-else-if="detail.auditStatus === 2" color="red">审核拒绝</a-tag>-->
<!--      </a-descriptions-item>-->
      <a-descriptions-item label="审核原因">{{ detail.auditReason }}</a-descriptions-item>
      <a-descriptions-item label="创建时间">{{ detail.createTime }}</a-descriptions-item>
    </a-descriptions>
  </a-modal>
</template>

<script>
import { getMailApply } from '@/api/cloudplant/mailApply'

export default {
  name: 'DetailModal',
  data() {
    return { visible: false, detail: {} }
  },
  methods: {
    show(row) {
      getMailApply({ id: row.id }).then(response => {
        this.detail = response.data
        this.visible = true
      })
    }
  }
}
</script>
